import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-susuerte',
  templateUrl: './susuerte.component.html',
  styleUrls: ['./susuerte.component.css'],
})
export class SusuerteComponent implements OnInit {
  public convenioSusuerte: string;
  public referencia: string;

  constructor(private _dialog: MatDialog, @Inject(MAT_DIALOG_DATA) private _data: any) {}

  ngOnInit(): void {
    this.convenioSusuerte = this._data.convenioSusuerte.value;
    this.referencia = this._data.referencia;
  }

  public closedModal() {
    this._dialog.closeAll();
  }
}
